import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import t from 'react-translate';
import { validateMSTeamsCoOrganizers } from 'redux/actions/live-events';
import { useAppDispatch } from 'redux/store';
import { Props as NvTextInputProps } from 'shared/components/inputs/nv-text-input';
import { addAlertMessage } from 'redux/actions/alert-messages';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import { LiveSessionFormContext } from './live-session-form';
import HostValidator from './host-validator';

type MSTeamsCoOrganizerValidatorProps = Omit<NvTextInputProps, 'withForm' | 'name'> & {
  formName: string;
  disabled: boolean;
  host?: string;
  onValidation?: (isValid: boolean, value: string) => void;
  tooltip?: string
};

const MSTeamsCoOrganizerValidator = (props: MSTeamsCoOrganizerValidatorProps) => {
  const {
    formName,
    onValidation,
    ...restProps
  } = props;

  const dispatch = useAppDispatch();
  const { catalogId } = useContext(LiveSessionFormContext);
  const { watch } = useFormContext();

  const coorganizers = watch(formName);

  const handleValidHost = (isValid: boolean) => {
    onValidation?.(isValid, coorganizers);
  };

  const handleValidate = async (coOrganizerIds: string) => {
    const result = await dispatch(validateMSTeamsCoOrganizers({ catalogId, coOrganizerIds })).unwrap();
    return result as { isValid: string[]; isInvalid: string[] };
  };

  const handleValidationError = (invalidHosts: string[]) => {
    const messageInput = invalidHosts.length > 1 ? invalidHosts.join(',') : invalidHosts[0];
    const message = invalidHosts.length > 1
      ? t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.MS_TEAMS_CO_ORGANIZER_ERROR.MULTIPLE(messageInput)
      : t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.MS_TEAMS_CO_ORGANIZER_ERROR.SINGLE(messageInput);
    dispatch(addAlertMessage({
      type: AlertMessageType.ERROR,
      header: t.FORM.OOPS(),
      message,
    }));
  };

  return (
    <HostValidator
      {...restProps}
      formName={formName}
      label={t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.CO_ORGANIZERS()}
      description={t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.CO_ORGANIZERS_DESCRIPTION()}
      placeholder={t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.ALTERNATIVE_HOSTS_EXAMPLE()}
      isMultipleHosts
      onValidHost={handleValidHost}
      onValidate={handleValidate}
      onValidationError={handleValidationError}
      showValidator
    />
  );
};

export default MSTeamsCoOrganizerValidator;
